import { render, staticRenderFns } from "./LeaveConfig.vue?vue&type=template&id=b6117d10&scoped=true"
import script from "./LeaveConfig.vue?vue&type=script&lang=js"
export * from "./LeaveConfig.vue?vue&type=script&lang=js"
import style0 from "./LeaveConfig.vue?vue&type=style&index=0&id=b6117d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6117d10",
  null
  
)

export default component.exports